import React, { useState } from 'react';
import {
  Box,
  Tooltip,
  Menu,
  Avatar,
  MenuItem,
  Divider,
  ListItemIcon,
  Typography,
  Button,
} from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ApprovalIcon from '@mui/icons-material/Approval';
import Logout from '@mui/icons-material/Logout';
import MonitorIcon from '@mui/icons-material/Monitor';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const UserMenu = ({ user, onLogout }) => {
  let navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const linkToProfile = () => {
    navigate('/profile');
  };

  const linkToDashboard = () => {
    navigate('/dashboard');
  };

  const linkToApproval = () => {
    navigate('/approvalmng');
  };

  const linkToApprovalMonitoring = () => {
    navigate('/approval_monitoring');
  };

  return (
    <Box>
      <Tooltip title="사용자 메뉴">
        <Button
          color="default"
          variant="text"
          onClick={handleClick}
          sx={{ borderRadius: '10px', px: 2 }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-end',
                alignContent: 'center',
                // 즐겨찾기/알림 배지 행이 넓어 ~1024px 부근에서 이 영역이 쥐어짜이면
                // noWrap 없이는 "관리자 담당" 같은 한글 텍스트가 띄어쓰기 없이 글자 하나씩
                // 세로로 줄바꿈되어(CJK 기본 line-break) 헤더 높이가 치솟고 아래 검색 영역을
                // 가려버린다. 폭을 제한하고 줄임표로 끊어 헤더 높이를 고정한다(2026-10-22).
                minWidth: 0,
                maxWidth: { xs: 96, md: 160 },
              }}
            >
              <Typography variant="subtitle2" component="div" noWrap sx={{ maxWidth: '100%' }}>
                {user?.usrNm} {user?.gradeNm}
              </Typography>
              <Typography
                variant="body2"
                component="div"
                color="text.secondary"
                noWrap
                sx={{ maxWidth: '100%' }}
              >
                {user?.dptNm}
              </Typography>
            </Box>
            <Box sx={{ px: 1 }}>
              {user?.profileImg ? (
                <Avatar
                  alt={user?.usrNm}
                  src={user?.profileImg}
                  sx={{ width: 32, height: 32 }}
                />
              ) : (
                <Avatar
                  sx={{ bgcolor: deepOrange[500], width: 32, height: 32 }}
                >
                  {user?.usrNm?.substring(0, 1)}
                </Avatar>
              )}
            </Box>
          </Box>
        </Button>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={() => linkToDashboard()}>
          <ListItemIcon>
            <DashboardIcon fontSize="small" />
          </ListItemIcon>
          DASHBOARD
        </MenuItem>
        <Divider />

        <MenuItem onClick={() => linkToProfile()}>
          <ListItemIcon>
            <ManageAccountsIcon fontSize="small" />
          </ListItemIcon>
          PROFLIE
        </MenuItem>
        <Divider />

        <MenuItem onClick={() => linkToApproval()}>
          <ListItemIcon>
            <ApprovalIcon fontSize="small" />
          </ListItemIcon>
          결재관리
        </MenuItem>
        <Divider />

        <MenuItem onClick={() => linkToApprovalMonitoring()}>
          <ListItemIcon>
            <MonitorIcon fontSize="small" />
          </ListItemIcon>
          결재 모니터링
        </MenuItem>
        <Divider />

        {/* 오픈소스 라이선스 고지 (2026-10-24, ksm_frontend에서 포팅). 빌드 시 생성되는 정적
            텍스트만 새 탭으로 연다(인증 우회 없음). */}
        <MenuItem
          onClick={() =>
            window.open('/third-party-notices.txt', '_blank', 'noopener,noreferrer')
          }
        >
          <ListItemIcon>
            <InfoOutlinedIcon fontSize="small" />
          </ListItemIcon>
          오픈소스 라이선스
        </MenuItem>
        <Divider />

        <MenuItem onClick={() => onLogout()}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          LOGOUT
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserMenu;
